export interface AffiliateCodeRequestModel {
  name: string;
  code: string;
}
